module.exports = __webpack_public_path__ + "img/01.40280a7e.png";